import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {createAuthHeaders} from '../../shared/utils/auth/create-auth-headers';
import {AuthToken} from '../models/auth-token';
import {AuthTokenDto} from './dto/auth-token.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly url = `${environment.loginUrl}/Authenticate`;

  constructor(private http: HttpClient) {}

  public login(username: string, password: string, url: string): Observable<AuthTokenDto> {
    return this.http.post<AuthTokenDto>(`${this.url}/login`, {username, password, url});
  }

  /**
   * Revokes the token on the server so it can no longer be used, even if it was copied out of the browser.
   * The token is passed in explicitly because the store has already cleared it by the time logout runs.
   * It is revoked on the login server and, when different, on the user's endpoint server, since both accept it.
   * Failures are ignored: logging off locally must never be blocked by the server.
   */
  public logout(token: AuthToken): Observable<void> {
    const urls = [this.url];
    if (token.endpointUrl) {
      const endpointUrl = `${token.endpointUrl}/api/Authenticate`;
      if (endpointUrl.toLowerCase() !== this.url.toLowerCase()) {
        urls.push(endpointUrl);
      }
    }

    const headers = createAuthHeaders(token);
    return forkJoin(
      urls.map(url => this.http.post<void>(`${url}/logoff`, null, {headers}).pipe(catchError(() => of(null))))
    ).pipe(map(() => undefined));
  }
}
